import { render, staticRenderFns } from "./AddReleaseProject.vue?vue&type=template&id=5ae381cb&scoped=true"
import script from "./AddReleaseProject.vue?vue&type=script&lang=js"
export * from "./AddReleaseProject.vue?vue&type=script&lang=js"
import style0 from "./AddReleaseProject.vue?vue&type=style&index=0&id=5ae381cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae381cb",
  null
  
)

export default component.exports